const LOCAL_STORAGE_WISHLIST_KEY = 'shopify-wishlist';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';

const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.card-product',
  headerWishlistBtn: '#header-wishlist-btn',
};

document.addEventListener('DOMContentLoaded', () => {
  initButtons();
  initGrid();
  updateHeaderWishlistButton();
  setupDelegatedEvents();
});

// Setup delegated event handling for dynamically added buttons
const setupDelegatedEvents = () => {
  document.addEventListener('click', (e) => {
    const button = e.target.closest('[button-wishlist]');
    if (button) {
      e.preventDefault();
      e.stopPropagation();
      const productHandle = button.dataset.productHandle || false;
      if (!productHandle) {
        console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
        return;
      }
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
      updateHeaderWishlistButton();
    }
  });
};

document.addEventListener('shopify-wishlist:updated', (event) => {
  console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
  updateHeaderWishlistButton();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});

const fetchProductCardHTML = (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

const setupGrid = async (grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');
  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  initButtons();

  const event = new CustomEvent('shopify-wishlist:init-product-grid', {
    detail: { wishlist: wishlist }
  });
  document.dispatchEvent(event);
};

const setupButtons = (buttons) => {
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');
    if (wishlistContains(productHandle)) button.classList.add(BUTTON_ACTIVE_CLASS);
    // Check if already has event listener to avoid duplicates
    if (button.dataset.wishlistInitialized) return;
    button.dataset.wishlistInitialized = 'true';
    button.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      updateWishlist(productHandle);
      button.classList.toggle(BUTTON_ACTIVE_CLASS);
    });
  });
};

const initGrid = () => {
  const grid = document.querySelector(selectors.grid) || false;
  if (grid) setupGrid(grid);
};

const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  if (buttons.length) setupButtons(buttons);
  else return;
  const event = new CustomEvent('shopify-wishlist:init-buttons', {
    detail: { wishlist: getWishlist() }
  });
  document.dispatchEvent(event);
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  const event = new CustomEvent('shopify-wishlist:updated', {
    detail: { wishlist: array }
  });
  document.dispatchEvent(event);

  return wishlist;
};

const updateWishlist = (handle) => {
  const wishlist = getWishlist();
  const indexInWishlist = wishlist.indexOf(handle);
  if (indexInWishlist === -1) wishlist.push(handle);
  else wishlist.splice(indexInWishlist, 1);
  return setWishlist(wishlist);
};

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const updateHeaderWishlistButton = () => {
  const headerWishlistBtn = document.querySelector(selectors.headerWishlistBtn);

  if (headerWishlistBtn) {
    const wishlist = getWishlist();
    const itemCount = wishlist.length;
    
    if (itemCount > 0) {
      headerWishlistBtn.classList.add(BUTTON_ACTIVE_CLASS);
    } else {
      headerWishlistBtn.classList.remove(BUTTON_ACTIVE_CLASS);
    }
  }
};

const resetWishlist = () => {
  return setWishlist([]);
};

// Update all wishlist buttons state on the page
const updateAllWishlistButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (productHandle) {
      if (wishlistContains(productHandle)) {
        button.classList.add(BUTTON_ACTIVE_CLASS);
      } else {
        button.classList.remove(BUTTON_ACTIVE_CLASS);
      }
    }
  });
};

// Make function globally available for Vue to call
window.initWishlistButtons = () => {
  updateAllWishlistButtons();
  updateHeaderWishlistButton();
};
